// extracted by mini-css-extract-plugin
export default {"miniQuizSearchResultCard":"miniQuizSearchResultCard__MjRlO","noBorder":"noBorder__NTNhN","hed":"hed__MzkyN","dek":"dek__NDA0N"};